import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { faTachometerAlt, faHospital, faUsers, faCreditCard, faHeadset, faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AdminSidebar = () => {
  return (
    <Nav className="flex-column p-3">
      <h4 className="text-center mb-4">Admin Panel</h4>
      <LinkContainer to="/admin/dashboard">
        <Nav.Link className="text-white"><FontAwesomeIcon icon={faTachometerAlt} className="me-2" /> Dashboard</Nav.Link>
      </LinkContainer>
      <LinkContainer to="/admin/entidades">
        <Nav.Link className="text-white"><FontAwesomeIcon icon={faHospital} className="me-2" /> Clínicas</Nav.Link>
      </LinkContainer>
      <LinkContainer to="/admin/usuarios">
        <Nav.Link className="text-white"><FontAwesomeIcon icon={faUsers} className="me-2" /> Usuários</Nav.Link>
      </LinkContainer>
      <LinkContainer to="/admin/assinaturas">
        <Nav.Link className="text-white"><FontAwesomeIcon icon={faCreditCard} className="me-2" /> Assinaturas</Nav.Link>
      </LinkContainer>
      <LinkContainer to="/admin/fluxopay">
        <Nav.Link className="text-white"><FontAwesomeIcon icon={faWallet} className="me-2" /> Fluxopay</Nav.Link>
      </LinkContainer>
      <LinkContainer to="/admin/suporte">
        <Nav.Link className="text-white"><FontAwesomeIcon icon={faHeadset} className="me-2" /> Suporte</Nav.Link>
      </LinkContainer>
      {/* Adicionar mais links conforme necessário */}
    </Nav>
  );
};

export default AdminSidebar;
